/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const get_current_user = /* GraphQL */ `
  query Get_current_user {
    get_current_user
  }
`;
export const list_users = /* GraphQL */ `
  query List_users($input: userInputs) {
    list_users(input: $input)
  }
`;
export const list_facilities = /* GraphQL */ `
  query List_facilities($input: facilityInputs) {
    list_facilities(input: $input)
  }
`;
export const list_facility_users = /* GraphQL */ `
  query List_facility_users($input: facilityUserInputs) {
    list_facility_users(input: $input)
  }
`;
export const list_my_facilities = /* GraphQL */ `
  query List_my_facilities($input: myFacilitiesInput) {
    list_my_facilities(input: $input)
  }
`;
export const list_physicians = /* GraphQL */ `
  query List_physicians($input: physicianInputs) {
    list_physicians(input: $input)
  }
`;
export const list_affliations = /* GraphQL */ `
  query List_affliations {
    list_affliations
  }
`;
export const list_reports = /* GraphQL */ `
  query List_reports($input: listReportInputs) {
    list_reports(input: $input)
  }
`;
export const list_pdf_extraction = /* GraphQL */ `
  query List_pdf_extraction($input: listPdfExtractionInputs) {
    list_pdf_extraction(input: $input)
  }
`;
export const list_pdf_conversation = /* GraphQL */ `
  query List_pdf_conversation($input: listPdfConversationInputs) {
    list_pdf_conversation(input: $input)
  }
`;
export const list_facilities_pending_review = /* GraphQL */ `
  query List_facilities_pending_review($input: facilityInputs) {
    list_facilities_pending_review(input: $input)
  }
`;
export const list_residents = /* GraphQL */ `
  query List_residents($input: residentsInputs) {
    list_residents(input: $input)
  }
`;
export const list_resident_medications = /* GraphQL */ `
  query List_resident_medications($input: residentMedicationsInput) {
    list_resident_medications(input: $input)
  }
`;
export const list_resident_recommendation = /* GraphQL */ `
  query List_resident_recommendation($input: residentRecommendationInput) {
    list_resident_recommendation(input: $input)
  }
`;
export const get_resident_object = /* GraphQL */ `
  query Get_resident_object($input: getResidentObjectInput) {
    get_resident_object(input: $input)
  }
`;
export const list_all_recommendation = /* GraphQL */ `
  query List_all_recommendation($input: allRecommendationInput) {
    list_all_recommendation(input: $input)
  }
`;
export const list_resident_notes = /* GraphQL */ `
  query List_resident_notes($input: residentNotesInput) {
    list_resident_notes(input: $input)
  }
`;
export const list_reviewed_residents = /* GraphQL */ `
  query List_reviewed_residents($input: reviewedResidentsInput) {
    list_reviewed_residents(input: $input)
  }
`;
export const list_organization_reviewed_residents = /* GraphQL */ `
  query List_organization_reviewed_residents(
    $input: listOrganizationReviewedResidentsInput
  ) {
    list_organization_reviewed_residents(input: $input)
  }
`;
export const get_organization = /* GraphQL */ `
  query Get_organization {
    get_organization
  }
`;
export const get_organization_api_usage = /* GraphQL */ `
  query Get_organization_api_usage($input: getOrganizationApiUsageInput) {
    get_organization_api_usage(input: $input)
  }
`;
export const list_medication_masters = /* GraphQL */ `
  query List_medication_masters($input: listMedicationMastersInputs) {
    list_medication_masters(input: $input)
  }
`;
export const list_master_medication_classes = /* GraphQL */ `
  query List_master_medication_classes($input: listMedicationMastersInputs) {
    list_master_medication_classes(input: $input)
  }
`;
export const list_categories = /* GraphQL */ `
  query List_categories($input: categoryInputs) {
    list_categories(input: $input)
  }
`;
export const list_template = /* GraphQL */ `
  query List_template($input: templateInputs) {
    list_template(input: $input)
  }
`;
export const list_announcement = /* GraphQL */ `
  query List_announcement($input: announcementInputs) {
    list_announcement(input: $input)
  }
`;
export const list_user_announcements = /* GraphQL */ `
  query List_user_announcements($input: announcementInputs) {
    list_user_announcements(input: $input)
  }
`;
export const list_announcement_views = /* GraphQL */ `
  query List_announcement_views($input: announcementInputs) {
    list_announcement_views(input: $input)
  }
`;
export const list_children = /* GraphQL */ `
  query List_children($input: fileFolderInputs) {
    list_children(input: $input)
  }
`;
export const search_nodes = /* GraphQL */ `
  query Search_nodes($input: fileFolderInputs) {
    search_nodes(input: $input)
  }
`;
export const list_facility_folders = /* GraphQL */ `
  query List_facility_folders($input: facilityUserInputs) {
    list_facility_folders(input: $input)
  }
`;
export const list_affiliations = /* GraphQL */ `
  query List_affiliations($input: listAffiliationsInputs) {
    list_affiliations(input: $input)
  }
`;
export const list_master_checklists = /* GraphQL */ `
  query List_master_checklists($input: MasterChecklistInput) {
    list_master_checklists(input: $input)
  }
`;
export const list_user_invoices = /* GraphQL */ `
  query List_user_invoices($input: invoiceInputs) {
    list_user_invoices(input: $input)
  }
`;
export const list_admin_invoices = /* GraphQL */ `
  query List_admin_invoices($input: invoiceInputs) {
    list_admin_invoices(input: $input)
  }
`;
export const list_user_checklist = /* GraphQL */ `
  query List_user_checklist($input: listUserChecklist1Input) {
    list_user_checklist(input: $input)
  }
`;
export const get_user_preference = /* GraphQL */ `
  query Get_user_preference($input: getUserPreferenceInput) {
    get_user_preference(input: $input)
  }
`;
export const get_license_usage_org_summary = /* GraphQL */ `
  query Get_license_usage_org_summary($input: getLicenseUsageOrgSummaryInput) {
    get_license_usage_org_summary(input: $input)
  }
`;
export const retrieve_and_generate = /* GraphQL */ `
  query Retrieve_and_generate($input: queryChatbotInput) {
    retrieve_and_generate(input: $input)
  }
`;
export const list_user_guide_main_modules = /* GraphQL */ `
  query List_user_guide_main_modules($input: userGuideTopicInputs) {
    list_user_guide_main_modules(input: $input)
  }
`;
export const list_user_guide_sub_modules = /* GraphQL */ `
  query List_user_guide_sub_modules($input: userGuideTopicInputs) {
    list_user_guide_sub_modules(input: $input)
  }
`;
export const list_pending_resident_reminders = /* GraphQL */ `
  query List_pending_resident_reminders($input: residentRemindersInputs) {
    list_pending_resident_reminders(input: $input)
  }
`;
export const list_resident_reminders = /* GraphQL */ `
  query List_resident_reminders($input: residentRemindersInputs) {
    list_resident_reminders(input: $input)
  }
`;
export const list_pending_facility_reminders = /* GraphQL */ `
  query List_pending_facility_reminders($input: facilityRemindersInputs) {
    list_pending_facility_reminders(input: $input)
  }
`;
export const list_facility_reminders = /* GraphQL */ `
  query List_facility_reminders($input: facilityRemindersInputs) {
    list_facility_reminders(input: $input)
  }
`;
export const list_facility_services = /* GraphQL */ `
  query List_facility_services($input: facilityServicesInputs) {
    list_facility_services(input: $input)
  }
`;
export const list_resident_labs = /* GraphQL */ `
  query List_resident_labs($input: residentLabsInputs) {
    list_resident_labs(input: $input)
  }
`;
export const list_lab_masters = /* GraphQL */ `
  query List_lab_masters($input: listLabMastersInputs) {
    list_lab_masters(input: $input)
  }
`;
export const support_agent_chat = /* GraphQL */ `
  query Support_agent_chat($input: aiSupportAssistantInputs) {
    support_agent_chat(input: $input)
  }
`;
export const get_ticket = /* GraphQL */ `
  query Get_ticket($input: ticketInputs) {
    get_ticket(input: $input)
  }
`;
export const list_tickets = /* GraphQL */ `
  query List_tickets($input: ticketInputs) {
    list_tickets(input: $input)
  }
`;
export const list_support_modules_masters = /* GraphQL */ `
  query List_support_modules_masters {
    list_support_modules_masters
  }
`;
